import React from 'react';
import PropTypes from 'prop-types';
import { dataHooks } from './constants';
import { ChevronRight, ChevronRightSmall } from '../../icons';
import { WixBaseUiEnvironmentContext } from '../../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
import _Symbol from '../symbol/symbol';
import compose from '../../hoc/compose';
var DrillInListItem = function DrillInListItem(props) {
  var context = React.useContext(WixBaseUiEnvironmentContext);
  var isResponsive = context.theme === 'responsive';
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('control-drill-in-list-item') + (props.disabled ? ' disabled' : '') + (props.contentAfter ? ' has-content-after' : ''),
    "data-aid": props.automationId,
    "data-hook": props.dataHook,
    onClick: props.disabled ? null : props.onClick,
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, props.translateIfNeeded(props.label)), props.description ? /*#__PURE__*/React.createElement("div", {
    key: "description",
    className: "description",
    "data-hook": dataHooks.drillInListItemDescription
  }, props.translateIfNeeded(props.description)) : null), props.contentAfter ? /*#__PURE__*/React.createElement("div", {
    key: "contentAfter",
    className: "content-after"
  }, props.contentAfter) : null, /*#__PURE__*/React.createElement(_Symbol, {
    className: "symbol-arrowRight"
  }, isResponsive ? /*#__PURE__*/React.createElement(ChevronRightSmall, {
    color: "B2"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    color: "B2"
  })));
};
DrillInListItem.displayName = 'DrillInListItem';
DrillInListItem.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Handles click event on the list item */
  onClick: PropTypes.func,
  /** Text content for item's label */
  label: PropTypes.string.isRequired,
  /** Text content for item's description */
  description: PropTypes.string,
  /** Content to display at the end of the item */
  contentAfter: PropTypes.element,
  /** When set to true, can not be clicked and applies disabled styles */
  disabled: PropTypes.bool
};
DrillInListItem.defaultProps = {
  disabled: false
};
export default compose(DrillInListItem);